import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../../utils/common'
import { Switch } from '../../../Switch'
import Text from '../../../Text'
import { QA_NAME_DASHBOARD_BIRDVIEW_CHART_CATALOG_ROW } from '../../DashboardBirdview.constants.qa'

import * as styles from './BirdviewChartCatalogRow.module.css'

function BirdviewChartCatalogRow({ row, onToggle }) {
  const { t } = useTranslation()

  function handleChange(isShown) {
    onToggle(row.id, isShown)
  }

  return (
    <div
      {...getQaSelector({
        context: row.id,
        value: QA_NAME_DASHBOARD_BIRDVIEW_CHART_CATALOG_ROW,
      })}
      className={styles.row}
    >
      <div className={styles.text}>
        <Text>{row.title}</Text>
        <Text isSecondary>{row.question}</Text>
      </div>
      {row.isSoon ? (
        <Text isSecondary className={styles.soon}>
          {t('DashboardBirdview.ChartCatalogSoonKey')}
        </Text>
      ) : (
        <Switch value={row.isShown} onChange={handleChange} />
      )}
    </div>
  )
}

export default BirdviewChartCatalogRow
